import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../../messages.tsx';

export const useParseSummaryValue = () => {
	const { formatMessage } = useIntl();

	// TODO: remove undefined prop type when cleaning up restore-mini-view-summary_y0gl1
	const parseSummaryValue = (
		summaryValue: string | null | undefined,
		issueType?: string,
	): string => {
		if (summaryValue === null) {
			return issueType
				? formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.noSummaryWithIssueTypeIssueTermRefresh
							: messages.noSummaryWithIssueType,
						{ issueType },
					)
				: '';
		}

		if (summaryValue) {
			return summaryValue;
		}

		return issueType
			? formatMessage(
					expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
						? messages.noSummaryWithIssueTypeIssueTermRefresh
						: messages.noSummaryWithIssueType,
					{ issueType },
				)
			: formatMessage(messages.noSummary);
	};

	return { parseSummaryValue };
};
